import React, { ReactElement } from "react";
import { FabButton } from "@kunduz/ui-components";
import { trackEventNext } from "@kunduz/utility-analytics";

export const FabButtonWithContext = (props: {
  href: string;
  image?: string;
  target: string;
  name?: string;
  calloutText?: string;
  position?: "left" | "right";
}): ReactElement => {
  const handleOnClickEvent = () => {
    trackEventNext({
      event: "Floating Action Button Clicked",
      id: props.name,
      type: props.name,
    });
  };

  return <FabButton {...props} onClick={handleOnClickEvent} />;
};
